var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.387 4.565A9.158 9.158 0 0 0 10 .857a9.158 9.158 0 0 0-7.387 3.708 9.62 9.62 0 0 0 0 11.476L10 25.857l7.387-9.816a9.62 9.62 0 0 0 0-11.476ZM10 5.13c2.67 0 4.855 2.224 4.855 4.943 0 2.72-2.185 4.944-4.855 4.944-2.67 0-4.856-2.225-4.856-4.944S7.33 5.13 10 5.13Z",
    fill: "#fff"
  })));
};
export default SvgLocation;